export default __webpack_public_path__ + "static/media/icon-fortmatic.04585e47.svg";